// extracted by mini-css-extract-plugin
export default {"google-pay-button":"style_google-pay-button__K0BAH","google-pay-proxy":"style_google-pay-proxy__bToZX"};